import { render, staticRenderFns } from "./NormalLink.vue?vue&type=template&id=47825446&"
import script from "./NormalLink.vue?vue&type=script&lang=js&"
export * from "./NormalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports